// What a visitor was looking at before they signed up, so the adult survey
// ("What brings you to Torch?") can arrive with that option already ticked.
// Kept in this browser only: a convenience, never relied on.
const KEY = 'torchSignupIntent';
const VALID = ['training', 'league', 'member', 'info'];

export function noteSignupIntent(pick) {
  if (!VALID.includes(pick)) return;
  try {
    const now = new Set(readSignupIntent());
    now.add(pick);
    localStorage.setItem(KEY, JSON.stringify([...now]));
  } catch (e) { /* storage off: nothing to remember */ }
}

export function readSignupIntent() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(v) ? v.filter(p => VALID.includes(p)) : [];
  } catch (e) { return []; }
}

/** "training,league" from ?pick= into the same shape. */
export function parsePicks(s) {
  return String(s || '').split(',').map(p => p.trim()).filter(p => VALID.includes(p));
}
